<template>
    <div>
        <div id="referenciaDesaparecen">
            <div id="filtro">
                <div class="row">
                    <div class="col-2 d-flex alinng-rigth mt-2 p-0">
                        <label for="titulo-buscar">Filtro:</label>         
                    </div>
                    <div class="col-10 align-left p-0">
                       <b-form-input id="titulo-buscar" type="text" v-model="criterio[0]" trim ></b-form-input>
                    </div>
                </div>  
            </div>      
            <div id="referenciaDesaparecen1">
                <b-button v-b-modal.modal-alta class="btn btn-success btn_desap grow" :hidden="mostrarAlta"  @click="alta1()">Alta 
                    <b-icon icon="file-earmark-plus" aria-hidden="true"> </b-icon>
                </b-button>
                <!-- -->
                <b-button v-b-modal.modal-alta class="btn btn-success btn_desap grow" :hidden="mostrarModificarEliminar" @click="modificar1()">Modificar 
                    <b-icon icon="file-text" aria-hidden="true">  </b-icon>
                </b-button>
                <b-button v-b-modal.modal-alta class="btn btn-success btn_desap grow" :hidden="mostrarModificarEliminar" @click="eliminar1()">Eliminar 
                   <b-icon icon="trash-fill" aria-hidden="true"> </b-icon> 
                </b-button>
                <b-button v-b-modal.modal-buscar class="btn btn-success btn_desap grow" >Buscar
                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                </b-button>
            </div>  
        </div>

        <b-modal id="modal-buscar" title="Buscar">
            <div class="">
              <div>
                  <div class="row">
                      <div class="col d-flex justify-content-center align-self-center">
                          <label for="titulo-buscar">Desde:</label>         
                      </div>
                      <div class="col-9 align-self-center">
                          <b-form-datepicker id="example-datepicker" @input="modificarFecha1" v-model="fecha1" class="mb-2"style="width:320px"></b-form-datepicker>
                      </div>
                  </div>  
                  <div class="row">         
                      <div class="col d-flex justify-content-center align-self-center">
                          <label for="titulo-buscar">hasta:</label>         
                      </div>
                      <div class="col-9 align-self-center">
                          <b-form-datepicker id="example-datepicker1" @input="modificarFecha2" v-model="fecha2" class="mb-2"style="width:320px"></b-form-datepicker>
                      </div>          

                  </div> 
                  <div class="row"> 
                      <div class="col d-flex justify-content-center align-self-center">
                          <label>Tipo:</label>    
                      </div>
                      <div class="col-9 align-self-center">
                          <b-form-select 
                              value-field="id"
                              text-field="detalle"
                              v-model="filtDisposiciones.tipo"
                              @change="filtroTemas(filtDisposiciones.tipo)"
                              :options="array_tipo_disposiciones">
                          </b-form-select>                                
                      </div>
                  </div>
                  <div class="row" :hidden="mostrarAlta"> 
                      <div class="col d-flex justify-content-center align-self-center">
                          <label>Temas:</label>    
                      </div>
                      <div class="col-9 align-self-center">
                          <b-form-select 
                              value-field="id"
                              text-field="texto"
                              v-model="filtDisposiciones.tema"
                              :options="arrayTemaDisposicionesFiltrado">
                          </b-form-select>          
                      </div>
                  </div>                             
              </div>
            </div>
            <template v-slot:modal-footer="{ ok }" >
                <b-button id="CerrarBuscar" variant="secondary" @click="ok()">Cancelar</b-button>
                <b-button variant="success" @click="buscar()">Buscar
                    <b-icon icon="search" aria-hidden="true"> </b-icon>
                </b-button >
            </template>   
        </b-modal>

        <b-modal id="modal-titulo" :title="'Titulo: '+romanize(insertarTitulo)" size="lg" >
            <div class="container">
                <div class="row pb-2">
                    <b-col sm="1">
                        <label class="pt-2" for="titulo-estado">Nombre:</label>        
                    </b-col>  
                    <b-col sm="11">
                        <b-form-input
                            v-model="nombreTitulo"
                            maxlength="120"
                        ></b-form-input>
                    </b-col> 
                </div>  
                <div class="row pb-2">
                    <div class="col-12 d-flex justify-content-start align-self-center">
                        <div id="summernoteAnexo"></div>
                    </div>
                </div>  
            </div>

            <template v-slot:modal-footer="{ ok }" >
                <b-button variant="danger" :hidden="mostrarAltaTitulo" @click="eliminarTitulo()">Eliminar Titulo {{romanize(titulosModificar+1) }}
                    <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                </b-button >            
                <b-button variant="primary" :hidden="mostrarAltaTitulo" @click="cargarTituloModificar()">Cargar Titulo {{romanize(titulosModificar+1) }}
                    <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
                </b-button >
                <b-col sm="3" :hidden="!mostrarAltaTitulo" >
                    <b-form-select  
                        value-field="id"
                        text-field="texto"
                        v-model="insertarTitulo"
                        :options="arrayIdTitulos">
                    </b-form-select>     
                 </b-col>              
                <b-button variant="primary" :hidden="!mostrarAltaTitulo" @click="cargarTituloAlta()">Cargar Titulo    
                    <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
                </b-button >

                <b-button id="CerrarTitulo" variant="secondary" @click="ok()">Cancelar</b-button>
            </template>   
        </b-modal>

        <b-modal id="modal-alta" 
            header-bg-variant="success"
            size="xl" 
            :title="titulo+titulo1"
            @show.bs.modal="CargarSummernote">
            <div class="modal-body">
                <b-container class="bv-example-row">
                    <b-row align-v="start">
                        <b-col sm="9">
                            <b-row align-v="start">
                                <b-col sm="3">
                                    <b-form-input type="text" v-model="numeroDisposicion" :disabled="disableEliminar" :state="estadoNumero"></b-form-input>
                                </b-col>

                                <b-col sm="4">
                                    <b-form-input type="date" v-model="fechaDisposicion" :disabled="disableEliminar" :state="estadoFecha"></b-form-input> 
                                </b-col> 
                     
                                <b-col sm="5">
                                    <b-form-select 
                                        value-field="id"
                                        text-field="detalle"
                                        v-model="idTipoDisposicion"
                                        @change="filtroTemas(idTipoDisposicion)"
                                        :options="array_tipo_disposiciones"
                                        :disabled="disableEliminar"
                                        :state="estadoTipo">
                                    </b-form-select>          
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input 
                                        type="text" 
                                        v-model="pieDisposicion" 
                                        placeholder="Pie de la disposicion..."
                                        :disabled="disableEliminar" 
                                        :state="estadoPie">
                                    </b-form-input> 
                                </b-col>
                                <b-col sm="4">
                                    <b-form-select 
                                        value-field="id"
                                        text-field="detalle"
                                        v-model="idEstado"
                                        :options="array_estados_disposiciones"
                                        :disabled="disableEliminar"
                                        :state="estadoEstado">
                                    </b-form-select>            
                                </b-col>
                                      
                                <b-col sm="12">
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="descripcionDisposicion"
                                        placeholder="Descripción de la dispoisicion..."
                                        rows="2"
                                        max-rows="2"
                                        maxlength="245"
                                        :disabled="disableEliminar"
                                        :state="estadoDescripcion">
                                    </b-form-textarea>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col sm="3">
                            <b-row>
                                <b-col sm="12">  
                                    <b-form-group :label="'Seleccione los tema: '+cantTemas">
                                        <b-form-checkbox-group class="overflow-auto"  size="sm" style="height:120px;"
                                            id="checkbox-group-1"
                                            v-model="temasSeleccionados"
                                            value-field="id"
                                            text-field="texto"
                                            :options="arrayTemaDisposicionesFiltrado"
                                        ></b-form-checkbox-group>    <!--  style="height:150px; background: red;" -->
                                    </b-form-group>
                                </b-col> 
                            </b-row>

                        </b-col> 
                    </b-row>

                    <b-row align-v="start">
                        <b-col sm="12">
                            <div class="row">
                                <div class="col-12 d-flex justify-content-center align-self-center">
                                  <label>Texto del Expediente:</label>
                                </div>  
                            </div>  
                            <div class="row">
                                <div class="col-12 d-flex justify-content-start align-self-center">
                                  <textarea id="summernote" name="editordata"></textarea> 
                                </div>
                            </div>         
                        </b-col> 
                        <b-row align-h="start" class="p-1">
                            <div>
                                <b-button-group v-for="(value,key) in anexos">
                                    <b-button v-b-modal.modal-anexo class="mr-1" variant="success" @click="cargarSummernoteAnexos(false,key)">Editar Anexo {{romanize(key+1)}}
                                    </b-button>
                                </b-button-group>
                                <b-button v-b-modal.modal-anexo class="m-2" variant="warning" @click="cargarSummernoteAnexos(true,anexos.length+1)">Cargar Anexo {{romanize(anexos.length+1)}}
                                </b-button >                    
                            </div>
                            <b-row align-v="start" class="p-1">
                                <div>
                                    <b-button-group v-for="(value,key) in titulos">
                                        <b-button v-b-modal.modal-titulo v-b-tooltip.hover class="mt-1 ml-1" :title="value.nombre" variant="primary" @click="cargarSummernoteTitulos(false,key)">Editar Titulo {{romanize(key+1)}}
                                        </b-button>
                                    </b-button-group>
                                    <b-button v-b-modal.modal-titulo class="mt-1 ml-2" variant="warning" @click="cargarSummernoteTitulos(true,titulos.length)">Cargar Titulo {{romanize(titulos.length+1)}}
                                    </b-button>   
                                </div>
                            </b-row>

                        </b-row>


                    </b-row>
                </b-container>  
       
            </div>
            <template v-slot:modal-footer="{ ok }" >
                <b-button id="BotonOkAlta" variant="secondary" @click="ok()">Cancelar</b-button>
                <b-button id='Boton_Alta' variant="success" :hidden="mostrarBotonAlta" @click="alta()">Guardar Disposición       
                  <b-icon icon="cloud-upload" aria-hidden="true"> </b-icon>
                </b-button >
                <b-button id='Boton_Modificar' variant="success" :hidden="mostrarBotonModificar" @click="modificar()">Guardar Disposición
                  <b-icon icon="cloud-upload" aria-hidden="true"> </b-icon>
                </b-button >
                <b-button id='Boton_Eliminar' variant="danger" :hidden="mostrarBotonEliminar" @click="eliminar()">Eliminar Disposición
                  <b-icon icon="trash-fill" aria-hidden="true"> </b-icon>
                </b-button >
            </template>
        </b-modal>

        <b-modal id="modal-anexo" :title="'Anexo: '+romanize(insertarAnexo)" size="lg" >
            <div class="">
                <div>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-start align-self-center">
                            <div id="summernoteAnexo"></div>
                        </div>
                    </div>  
                    <div class="row">
                        <b-col sm="6">
                            <b-form-file
                                v-model="anexoPDF"
                                :state="Boolean(anexoPDF)"
                                accept="application/pdf"
                                placeholder="Elija el archivo Anexo."
                                @input="cargarAnexoPDF()"
                            ></b-form-file>
                        </b-col>
                        <b-col sm="6" :hidden="existeImagen64">
                            <b-embed
                                type="embed"
                                aspect="16by9"
                                :src="MostrarImagen64"
                            ></b-embed>
                        </b-col>

                    </div>
                </div>
            </div>
            <!-- -->
            <template v-slot:modal-footer="{ ok }" >
                <b-button id='BotonAlta' variant="danger" :hidden="mostrarAltaAnexo" @click="eliminarAnexo()">Eliminar Anexo  {{romanize(insertarAnexo)}}     
                    <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                </b-button >
                 <b-col sm="3" :hidden="!mostrarAltaAnexo" >
                    <b-form-select  
                        value-field="id"
                        text-field="texto"
                        v-model="insertarAnexo"
                        :options="arrayIdAnexos">
                    </b-form-select>     
                 </b-col>               
                <b-button id='BotonAlta' variant="success" :hidden="!mostrarAltaAnexo" @click="cargarAnexoAlta()">Cargar Anexo   {{romanize(insertarAnexo)}}
                    <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
                </b-button >
                <b-button id='BotonModificar' variant="success" :hidden="mostrarAltaAnexo" @click="cargarAnexoModificar()">Cargar Anexo  {{romanize(insertarAnexo)}}
                    <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
                </b-button >

                <b-button id="CerrarAnexo" variant="secondary" @click="ok()">Cancelar</b-button>
            </template>   
        </b-modal>

        <b-modal id="modal-anexo-mostrar" title="Anexos" size="lg" >
            <div class="">
                <div>
                    <div class="row" :hidden="!existeImagen64">
                        <div class="col-12 d-flex justify-content-start align-self-center">
                            <div id="summernoteAnexoMostrar"></div>
                        </div>
                    </div>  
                    <div class="row" :hidden="existeImagen64">
                        <b-col>
                            <b-embed
                                type="embed"
                                aspect="16by9"
                                :src="MostrarImagen64"
                                style="width:600px"
                            ></b-embed>
                        </b-col>
                    </div>
                </div>
            </div>
            <!-- -->
            <template v-slot:modal-footer="{ ok }" >
                <b-button id='BotonModificar' variant="success"  @click="descargarAnexo()">Descargar Anexo {{romanize(anexosModificar+1)}}
                </b-button >

                <b-button id="CerrarAnexo" variant="secondary" @click="ok()">Cancelar</b-button>
            </template>   
        </b-modal>

        <b-modal id="modal-titulo-mostrar" :title="'Titulo ' +romanize(titulosModificar+1)+': '+nombreTitulo" size="lg" >
            <div class="">
                <div>
                    <div class="row" :hidden="!existeImagen64">
                        <div class="col-12 d-flex justify-content-start align-self-center">
                            <div id="summernoteAnexoMostrar"></div>
                        </div>
                    </div>  
                </div>
            </div>
            <!-- -->
            <template v-slot:modal-footer="{ ok }" >
                <b-button id='BotonModificar' variant="primary"  @click="descargarTitulo()">Descargar Titulo {{romanize(titulosModificar+1)}}
                </b-button >

                <b-button id="CerrarAnexo" variant="secondary" @click="ok()">Cancelar</b-button>
            </template>   
        </b-modal>        

        <b-modal id="modal-link" 
            size="xl" 
            title="Disposiciones" 
            header-bg-variant="success" 
            ok-only>
            <div class="modal-link">
                <div>
                    <div id="summernoteLink"></div>
                </div>
                <div class="col-12 align-self-center mt-1">
                    <b-button-group v-for="(value,key) in anexos">
                        <b-button v-b-modal.modal-anexo-mostrar class="mr-1" variant="success" @click="mostrarSummernoteAnexos(key)">Mostrar Anexo {{romanize(key+1)}}
                        </b-button>
                    </b-button-group>
                </div>    
                <div class="col-12 align-self-center mt-1"> 
                    <b-button-group v-for="(value,key) in titulos">
                        <b-button v-b-modal.modal-titulo-mostrar class="mr-1" variant="primary" @click="mostrarSummernoteTitulos(key)">Mostrar Titulo {{romanize(key+1)}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <a id="link" :href="link" target>{{nombreLink}}</a><br>
                <b-button id="BotonOk" variant="success" @click="ok()">OK</b-button>
                <b-button variant="success" @click="Descargar()">Descargar en PDF</b-button>
            </template>
        </b-modal>

        <b-table hover 
            small
            selectable
            sticky-header="500px"
            select-mode="single" 
            @row-selected="onRowSelected"
            :fields="EncabezadoDisposiciones" 
            :items="array_disposiciones"
            :tbody-tr-class="rowClass"
            :filter="criterio"       
            :filter-function="filtro">
            <template v-slot:cell(Numero)="row" >

                <b-button v-if="row.item.fecha>='2018-01-01'"
                    v-b-modal.modal-link
                    variant="link" 
                    @click="CargarCuerpo(row.item);"
                    class="mb-2" style="width: 120px;" >
                    {{row.item.tipo}} {{row.item.numero}}
                    <b-badge pill variant="success" v-if="row.item.anexos>0">{{row.item.anexos}}</b-badge>
                    <b-badge pill variant="primary" v-if="row.item.titulos>0">{{row.item.titulos}}</b-badge>
                </b-button>         
                <b-button v-if="row.item.fecha<'2018-01-01'"
                    variant="link" 
                    @click="DescargarAntes2018(row.item);"
                    class="mb-2" style="width: 120px;" >
                    {{row.item.tipo}} {{row.item.numero}} 
                </b-button> 
            </template>

            <template #cell(show_details)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2" :hidden="row.item.temas.length==0">
                    {{row.item.temas.length}}
                </b-button>      
            </template>

            <template #row-details="row">
                <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>temas:</b></b-col>
                    <b-col>{{ row.item.temas_texto }}</b-col>
                </b-row>  
            </template>
        </b-table>

        <a id="link1" href="" target></a>
        <a id="link2" href="" target></a>
        <a id="Anexo" href="" target></a>    
    </div>
</template>

<style>
  #filtro{
    top: -85px;
    position: absolute;
    z-index: 10;
    right: -70px;
  }
</style>

<script>
  import { mapState, mapActions } from 'vuex';
  import { mapMutations } from 'vuex'

  const $ = require("jquery")
  import "summernote/dist/summernote-lite.min.css";
  import "summernote/dist/summernote-lite.min"; 

  export default {
    name: 'Home', 
    components: {
  
    },
    computed:{
        ...mapState(['host','fechai','fechaf','array_fotos','array_expedientes','array_tipo_disposiciones','array_disposiciones','array_temas_disposiciones','array_estados_disposiciones','fechai','fechaf','array_usuario']),
        cantTemas(){
          return this.temasSeleccionados.length
        },       
        estadoPie(){
          return this.pieDisposicion.length > 40 ? true : false
        },
        estadoNumero(){
          return this.numeroDisposicion != '' ? true : false;   
        },    
        estadoFecha(){
          return this.fechaDisposicion != '' ? true : false;    
        },
        estadoTipo(){
          return this.idTipoDisposicion != 0 ? true : false;    
        },
        estadoTema(){
          return this.idTemaDisposicion != 0 ? true : false
        },    
        estadoDescripcion(){
          return this.descripcionDisposicion.length > 40 ? true : false
        },
        estadoEstado(){
          return this.idEstado != 0 ? true : false
        },
        mostrarAlta(){
          return this.array_usuario.TipoUsuarioHCD=='1' ? false : true
        },
        mostrarModificarEliminar(){
          return this.array_usuario.TipoUsuarioHCD=='1' && this.idEditar!=0 ? false : true
        },
        mostrarBotonAlta(){
          return this.titulo=='Alta de Disposición' ? false : true
        },
        mostrarBotonModificar(){
          return this.titulo=='Modificar '? false : true
        },
        mostrarBotonEliminar(){
          return this.titulo=='Eliminar '? false : true
        },
        disableEliminar(){
          return this.titulo!='Eliminar ' ? false : true
        },
        existeImagen64(){
            return this.MostrarImagen64=='' ? true : false
        },
        mostrarAltaAnexo(){
            return this.altaAnexos==true ? true : false
        },
        mostrarAltaTitulo(){
            return this.altaTitulos==true ? true : false
        },        
    },  
    methods:{
        ...mapActions(['CargarDisposiciones','CargarTipoDisposiciones','CargarTemasDisposiciones','CargarEstadosDisposiciones']),
        ...mapMutations(['valorFechai','valorFechaf','actualizarArrayDisposiciones']),
        cargarRegistro(dato){  
            this.numeroDisposicion=dato.num_interno;
            this.numInterno=dato.num_interno;
            this.fechaDisposicion=dato.fecha;
            this.idEditar=dato.id;
            this.descripcionDisposicion=dato.descripcion;
            this.idTipoDisposicion=dato.id_tipo;
            this.idTemaDisposicion=dato.id_tema;
            this.cuerpoProyectoEditar=dato.cuerpo;
            this.pieDisposicion=dato.pie;
            this.idEstado=dato.id_estado;
            this.titulo1='N° '+dato.numero;
            this.temasSeleccionados=dato.temas;
            if (dato.id_tipo==1){
              this.titulo1='Ordenanza N°'+dato.numero;
            }
            if (dato.id_tipo==2){
              this.titulo1='Comunicación N°'+dato.numero;
            }
            if (dato.id_tipo==3){
              this.titulo1='Resolución N°'+dato.numero;
            }
        },  

        cargarTituloAlta(){
            //this.titulos.push({nombre:this.nombreTitulo, imagen64:$('#summernoteAnexo').summernote('code')});
            console.log(this.titulos);
            this.titulos.splice(this.insertarTitulo-1,0,{nombre:this.nombreTitulo, imagen64:$('#summernoteAnexo').summernote('code')});
            console.log(this.titulos);
            document.getElementById('CerrarTitulo').click();
        },

        cargarTituloModificar(){
            console.log(this.titulos);
            this.titulos[this.titulosModificar]['nombre']=this.nombreTitulo;
            this.titulos[this.titulosModificar]['imagen64']=$('#summernoteAnexo').summernote('code');
            console.log(this.titulos);
            document.getElementById('CerrarTitulo').click();
        }, 
        eliminarTitulo(){
            this.titulos.splice(this.titulosModificar, 1);
            document.getElementById('CerrarTitulo').click();
        },       
        romanize(num) { 
            var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},
            roman = '',i; 
            for ( i in lookup ) { 
                while ( num >= lookup[i] ) {
                    roman += i; num -= lookup[i]; 
                } 
            } 
            return roman; 
        },
        Descargar(){
            document.getElementById('link1').click();
            document.getElementById('BotonOk').click();
        },
        cargarAnexoModificar(){
            if (this.anexoPDF==null){
                //this.anexos.push();
                this.anexos[this.anexosModificar]=$('#summernoteAnexo').summernote('code');
            }else{
                this.anexos[this.anexosModificar]=this.anexoPDF64;
            }
            document.getElementById('CerrarAnexo').click();
        },
        DescargarAntes2018(dato){
            if (dato.tipo=='Ordenanza'){
              document.getElementById('link2').href='//www.hcdrauch.com.ar/dispos/'+dato.tipo+dato.numero.trim()+'.doc';
            }
            if (dato.tipo=='Comunicación'){
              document.getElementById('link2').href='//www.hcdrauch.com.ar/dispos/Comunicacion'+dato.numero.trim()+'.doc';
            }   
            if (dato.tipo=='Resolución'){
              document.getElementById('link2').href='//www.hcdrauch.com.ar/dispos/Resolucion'+dato.numero.trim()+'.doc';
            }                   
            document.getElementById('link2').click();
        },
        CargarCuerpo(dato){
            if (dato.fecha.substr(0,4)>'2017'){
                this.cargarRegistro(dato);
            }else{
                 this.idEditar=0;
            }
            this.cuerpoProyecto='<div style="text-align: center;"><u><b>'+dato.tipo+' N°'+dato.numero+'</b></u></div>'
            this.cuerpoProyecto=this.cuerpoProyecto+'<div style="text-align: center;"></div>'+dato.cuerpo;
            this.idDescargar=dato.id;
            this.CargarDatos();
            this.link=this.host+'disposicion_pdf.php?nro='+this.idDescargar;
            this.nombreLink=dato.tipo+' N°'+dato.numero; 
            //this.nombreLink='Expediente: '+dato.numero+' V'+dato.version;
            this.cargarAnexos(); 
            this.cargarTitulos();
        },
        cargarSummernoteAnexos(alta,valor){
            this.anexoPDF=null;
            this.MostrarImagen64='';
            if(alta){
                this.altaAnexos=true;
                this.insertarAnexo=valor;
            }else{
                this.altaAnexos=false;
                this.insertarAnexo=valor+1;
            }
            this.anexosModificar=valor;
            $(document).ready(function() {
                $('#summernoteAnexo').summernote({
                    lang: 'es-ES',
                    width: 800,
                    tabsize: 4,
                    toolbar: [
                        ['font', ['bold', 'underline', 'clear']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                        ['insert', ['link', 'picture', 'video']],
                        ['view', ['fullscreen']]
                    ],

                    callbacks: {
                        onPaste: function (e) {
                            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                            e.preventDefault();
                            document.execCommand('insertText', false, bufferText);
                        }
                    }
                });
            });             
            if (typeof this.anexos[valor] != "undefined"){
                var texto='';
                if (this.anexos[valor].substr(0, 20)!='data:application/pdf'){
                    texto=this.anexos[valor];
                }else{
                    this.MostrarImagen64=this.anexos[valor];
                }
                $(document).ready(function(){
                    $('#summernoteAnexo').summernote('code', texto);
                });
            }
        }, 
        cargarSummernoteTitulos(alta,valor){
            this.tituloPDF=null;
            this.MostrarImagen64='';            
            $(document).ready(function() {
                $('#summernoteAnexo').summernote({
                    lang: 'es-ES',
                    width: 800,
                    tabsize: 4,
                    toolbar: [
                        ['font', ['bold', 'underline', 'clear']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                        ['insert', ['link', 'picture', 'video']],
                        ['view', ['fullscreen']]
                    ],
                    callbacks: {
                        onPaste: function (e) {
                            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                            e.preventDefault();
                            document.execCommand('insertText', false, bufferText);
                        }
                    }
                });
            });

            this.titulosModificar=valor;
            this.insertarTitulo=valor+1;
            var texto='';
            this.nombreTitulo='';
            if(alta){
                this.altaTitulos=true;
            }else{
                this.altaTitulos=false;
                this.nombreTitulo=this.titulos[valor]['nombre'];
                if (this.titulos[valor]['imagen64'].substr(0, 20)!='data:application/pdf'){
                    texto=this.titulos[valor]['imagen64'];
                }else{
                    this.MostrarImagen64=this.titulos[valor]['imagen64'];
                }
                $(document).ready(function(){
                    $('#summernoteAnexo').summernote('code', texto);
                });
            }
        },
        mostrarSummernoteAnexos(valor){
            this.anexoPDF=null;
            this.MostrarImagen64='';
            this.anexosModificar=valor;         
            $(document).ready(function() {
                $('#summernoteAnexoMostrar').summernote({
                    lang: 'es-ES',
                    width: 800,
                    tabsize: 4,
                    toolbar: [
                    ],
                });
            });             
            if (typeof this.anexos[valor] != "undefined"){
                var texto='';
                if (this.anexos[valor].substr(0, 20)!='data:application/pdf'){
                    texto=this.anexos[valor];

                }else{
                    this.MostrarImagen64=this.anexos[valor];
                }
                $(document).ready(function(){
                    $('#summernoteAnexoMostrar').summernote('code', texto);
                    $('#summernoteAnexoMostrar').summernote('disable');
                });
            }
        },
        mostrarSummernoteTitulos(valor){
            this.anexoPDF=null;
            this.MostrarImagen64='';
            this.titulosModificar=valor;         
            $(document).ready(function() {
                $('#summernoteAnexoMostrar').summernote({
                    lang: 'es-ES',
                    width: 800,
                    tabsize: 4,
                    toolbar: [
                    ],
                });
            });             
            this.nombreTitulo=this.titulos[valor]['nombre'];
            if (this.titulos[valor]['imagen64'] != "undefined"){
                var texto='';
                if (this.titulos[valor]['imagen64'].substr(0, 20)!='data:application/pdf'){
                    texto=this.titulos[valor]['imagen64'];

                }else{
                    this.MostrarImagen64=this.titulos[valor]['imagen64'];
                }
                $(document).ready(function(){
                    $('#summernoteAnexoMostrar').summernote('code', texto);
                    $('#summernoteAnexoMostrar').summernote('disable');
                });
            }
        },       
        eliminarAnexo(){
            this.anexos.splice(this.anexosModificar, 1);
            document.getElementById('CerrarAnexo').click();
        },
        descargarAnexo(){
            if (this.MostrarImagen64.substr(0, 20)!='data:application/pdf'){
                document.getElementById('Anexo').href=this.host+'anexoPDF.php?id_expediente='+this.idEditar+'&anexos='+this.anexosModificar+'&nombre='+this.nombreLink+' Anexo '+this.romanize(this.anexosModificar+1)+'&tipo=disposicion';
                document.getElementById('Anexo').click();
            }else{
                const a = document.createElement("a");
                a.download = "DescargaAnexo "+this.romanize(this.anexosModificar+1);
                a.href = this.MostrarImagen64;
                //console.log(imagen);
                document.body.appendChild(a);
                a.click();                
            }
        },
        descargarTitulo(){
            if (this.MostrarImagen64.substr(0, 20)!='data:application/pdf'){
                document.getElementById('Anexo').href=this.host+'tituloPDFdisposiciones.php?id_expediente='+this.idEditar+'&numero='+this.titulosModificar+'&nombre='+this.nombreLink+'&titulo='+' Titulo '+this.romanize(this.titulosModificar+1)+'&tipo=disposicion';
                document.getElementById('Anexo').click();
            }else{
                const a = document.createElement("a");
                a.download = "DescargaTitulo "+this.romanize(this.titulosModificar+1);
                a.href = this.MostrarImagen64;
                //console.log(imagen);
                document.body.appendChild(a);
                a.click();                
            }
        },
        cargarAnexos: async function (){
            try{
                let newPost={
                    opcion:'CargarAnexoDisposiciones',
                    id_reg:this.idEditar
                };
                const entradasBD = await fetch(this.host+'anexos.php',{
                    method:'POST',
                    body: JSON.stringify(newPost),
                    headers:{
                      "Content-Type": "application/json"
                    }
                });
                const datos= await entradasBD.json();
                console.log(datos);
                this.anexos = datos.map(function(x) {
                   return x.imagen64;
                });

                this.arrayIdAnexos=[];
                for (var i=0; i<=this.anexos.length; i++) { 
                    this.arrayIdAnexos.push({id:i+1, texto:'Insertar Anexo '+this.romanize(i+1)});
                }
                console.log(this.arrayIdAnexos);

                console.log(this.anexos)
            }catch (error){
                console.log(error);
            }
        },
        cargarTitulos: async function (){
            try{
                let newPost={
                    opcion:'CargarTituloDisposiciones',
                    id_reg:this.idEditar
                };
                const entradasBD = await fetch(this.host+'titulos.php',{
                    method:'POST',
                    body: JSON.stringify(newPost),
                    headers:{
                      "Content-Type": "application/json"
                    }
                });
                const datos= await entradasBD.json();
                console.log(datos);
                this.titulos = datos.map(function(x) {
                   return {nombre:x.nombre, imagen64:x.imagen64};
                }); 
                this.arrayIdTitulos=[];
                for (var i=0; i<=this.titulos.length; i++) { 
                    this.arrayIdTitulos.push({id:i+1, texto:'Insertar Titulo '+this.romanize(i+1)});
                }
                console.log(this.arrayIdTitulos);
            }catch (error){
                console.log(error);
            }
        },
        makeToast(variant = null) {
          this.$bvToast.toast('El archivo es mayor a 800 Kilobyte', {
            title: `El archivo es demasiado grande`,
            variant: variant,
            solid: true
          })
        },
        cargarArchivoPDF: function (e){
          this.anexoPDF64=e.target.result;
          this.MostrarImagen64=this.anexoPDF64;
        },
        cargarAnexoAlta(){
            if (this.anexoPDF==null){
                //this.anexos.push($('#summernoteAnexo').summernote('code'));
                this.anexos.splice(this.insertarAnexo-1,0,$('#summernoteAnexo').summernote('code'));            
            }else{
                //this.anexos.push(this.anexoPDF64);
                this.anexos.splice(this.insertarAnexo-1,0,this.anexoPDF64); 
            }
            document.getElementById('CerrarAnexo').click();
        },
        cargarAnexoPDF: function (){
            if (this.anexoPDF!=null){
                if (this.anexoPDF.size<800000){
                    var fileReader=new FileReader();
                    fileReader.readAsDataURL(this.anexoPDF);
                    fileReader.addEventListener("load",this.cargarArchivoPDF,false);
                }else{
                    this.anexoPDF64= null;
                    this.makeToast('warning');
                }
            }
        },
        CargarDatos(){
            var datos=this.cuerpoProyecto;
            $(document).ready(function() {
                $('#summernoteLink').summernote({
                  lang: 'es-ES', height: 400, tabsize: 4,
                  toolbar: []
                });
                $('#summernoteLink').summernote('code', datos);
                $('#summernoteLink').summernote('disable');      
            });
            document.getElementById('link1').href=this.host+'disposicion_pdf.php?nro='+this.idDescargar;
            var as=this.host+'disposicion_pdf.php?nro='+this.idDescargar;
        },
        buscar(){
            this.CargarDisposiciones(this.filtDisposiciones);
            document.getElementById('CerrarBuscar').click();
        },
        modificarFecha1(){
            this.valorFechai(this.fecha1);
        },
        modificarFecha2(){
            this.valorFechaf(this.fecha2);
        },
        alta1(){
          this.titulo='Alta de Disposición';
          this.titulo1='';
          this.numeroDisposicion='';
          this.numInterno=0; 
          this.fechaDisposicion='';
          this.descripcionDisposicion='';
          this.idTipoDisposicion=0;
          this.idTemaDisposicion=0;
          this.idEstado=0;
          this.cuerpoProyectoEditar='';
          this.pieDisposicion='';

          //Cargar_summernote();
          $(document).ready(function() {

            $('#summernote').summernote('reset');
          });
        },
        modificar1(){
            this.titulo='Modificar ';
            var datos=this.cuerpoProyectoEditar;
            this.filtroTemasModificar();
            $(document).ready(function(){
                $('#summernote').summernote('code', datos);
            });
        },
        eliminar1(){
            this.titulo='Eliminar ';
            var datos=this.cuerpoProyectoEditar;
            $(document).ready(function() {
                $('#summernote').summernote('code', datos);
                $('#summernote').summernote('disable');
            }); 
        },
        alta: async function (){
            document.getElementById('BotonOkAlta').click();
            try{
                let newPost={
                    opcion:'Alta',
                    descripcion:this.descripcionProyecto,
                    num:this.numeroDisposicion,
                    descripcion:this.descripcionDisposicion,
                    texto:document.getElementById('summernote').value,
                    id_tipo_disposiciones1:this.idTipoDisposicion,
                    id_estado:this.idEstado,
                    id_temas1:this.temasSeleccionados,
                    fecha3:this.fechaDisposicion,
                    pie:this.pieDisposicion,
                    id_reg:this.idEditar,
                    anexos:this.anexos,
                    session:this.array_usuario.session
                };
                const entradasBD = await fetch(this.host+'disposiciones.php',{
                    method:'POST',
                    body: JSON.stringify(newPost),
                    headers:{
                      "Content-Type": "application/json"
                    }
                });
                this.CargarDisposiciones(this.filtDisposiciones);
            }catch (error){
                console.log(error);
            }  
        },
        modificar: async function (){
            document.getElementById('BotonOkAlta').click();
            try{
                let newPost={
                    opcion:'Modificar',
                    descripcion:this.descripcionProyecto,
                    num:this.numeroDisposicion,
                    descripcion:this.descripcionDisposicion,
                    texto:document.getElementById('summernote').value,
                    id_tipo_disposiciones1:this.idTipoDisposicion,
                    id_estado:this.idEstado,
                    id_temas1:this.temasSeleccionados,
                    fecha3:this.fechaDisposicion,
                    pie:this.pieDisposicion,
                    id_reg:this.idEditar,
                    anexos:this.anexos,
                    titulos:this.titulos,
                    session:this.array_usuario.session
                };
                console.log(newPost);
                const entradasBD = await fetch(this.host+'disposiciones.php',{
                    method:'POST',
                    body: JSON.stringify(newPost),
                    headers:{
                      "Content-Type": "application/json"
                    }
                });
                const datos= await entradasBD.json();
                console.log(datos);
                this.actualizarArrayDisposiciones(datos);
            }catch (error){
                console.log(error);
            }  
        },
        eliminar: async function (){
            document.getElementById('BotonOkAlta').click();
            try{
                let newPost={
                    opcion:'Eliminar',
                    id_reg:this.idEditar,
                    session:this.array_usuario.session
                };
                const entradasBD = await fetch(this.host+'disposiciones.php',{
                    method:'POST',
                    body: JSON.stringify(newPost),
                    headers:{
                      "Content-Type": "application/json"
                    }
                });
                this.CargarDisposiciones(this.filtDisposiciones);
            }catch (error){
                console.log(error);
            }  
        },
        filtroTemas(valor){
            this.filtDisposiciones.tema='0';
            this.temasSeleccionados=[];
            this.arrayTemaDisposicionesFiltrado = this.array_temas_disposiciones.filter(dato=>valor==dato.id_tipo || 0==dato.id); 
            this.pieDisposicion='';
            var dt = new Date(this.fechaDisposicion);
            var year  = dt.getFullYear();
            var month = (dt.getMonth() + 1).toString().padStart(2, "0");
            var day   = (dt.getDate() +1 ).toString().padStart(2, "0");
            
            if (valor== 1) {this.pieDisposicion='Ordenanza sancionada en sesión ordinaria del '+day + '-' + month + '-' + year};
            if (valor== 2) {this.pieDisposicion='Comunicación sancionada en sesión ordinaria del '+day + '-' + month + '-' + year};
            if (valor== 3) {this.pieDisposicion='Resolución sancionada en sesión ordinaria del '+day + '-' + month + '-' + year};
        },
        filtroTemasModificar(){
            this.arrayTemaDisposicionesFiltrado = this.array_temas_disposiciones.filter(dato=>this.idTipoDisposicion==dato.id_tipo || 0==dato.id);
        },
        onRowSelected(items) {
            if (items.length==1){
                if (items[0]['fecha'].substr(0,4)>'2017'){
                    this.numeroDisposicion=items[0]['num_interno'];
                    this.numInterno=items[0]['num_interno'];
                    this.fechaDisposicion=items[0]['fecha'];
                    this.idEditar=items[0]['id'];
                    this.descripcionDisposicion=items[0]['descripcion'];
                    this.idTipoDisposicion=items[0]['id_tipo'];
                    this.idTemaDisposicion=items[0]['id_tema'];
                    this.cuerpoProyectoEditar=items[0]['cuerpo'];
                    this.pieDisposicion=items[0]['pie'];
                    this.idEstado=items[0]['id_estado'];
                    this.titulo1='N° '+items[0]['numero'];
                    this.temasSeleccionados=items[0]['temas'];
                    if (items[0]['id_tipo']==1){
                      this.titulo1='Ordenanza N°'+items[0]['numero'];
                    }
                    if (items[0]['id_tipo']==2){
                      this.titulo1='Comunicación N°'+items[0]['numero'];
                    }
                    if (items[0]['id_tipo']==3){
                      this.titulo1='Resolución N°'+items[0]['numero'];
                    }
                    this.cargarAnexos(); 
                    this.cargarTitulos();
                    // this.arrayTemaDisposicionesFiltrado = this.arrayTemaDisposiciones.filter(dato=>this.idTipoDisposicion==dato.id_tipo);
                }else{
                    this.idEditar=0;
                }
            }
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.id_tipo == 1 ){
                if (item.id_estado == 3){ //Derogada
                    return 'table-success text-danger';
                }else{
                    if (item.id_estado == 2){ //Modificada
                      return 'table-success text-primary';
                    }else{
                      return 'table-success';
                    }         
                }
            }
            if (item.id_tipo == 2) return 'table-primary';
            if (item.id_tipo == 3) return 'table-warning';
        },
        modificarFecha1(){
            this.valorFechai(this.fecha1);
        },
        modificarFecha2(){
            this.valorFechaf(this.fecha2);
        },
        CargarSummernote(){
            if (this.array_usuario.TipoUsuarioHCD=='1'){
                  $(document).ready(function() {
                    $('#summernote').summernote({
                      lang: 'es-ES', 
                      tabsize: 6,
                      toolbar: [
                        ['style', ['style']],
                        ['font', ['bold', 'underline', 'clear']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                        ['view', ['fullscreen', 'codeview', 'help']]
                      ]
                    });
                  })
            }else{
                  $(document).ready(function() {
                    $('#summernote').summernote({
                      lang: 'es-ES', 
                      tabsize: 4,
                      toolbar: [
                        ['style', ['style']],
                        ['font', ['bold', 'underline', 'clear']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']]
                      ]
                    });
                  })      
            }
            this.CargarTemasDisposiciones();
        },
        readySummernote(editor) {
            editor.summernote('code', this.contents);
            editor.$on("change", contents => {
                this.texto = contents;
            });
        },
        filtro(row, filter) {
          if (row.cuerpo.toUpperCase().includes(filter[0].toUpperCase()) || row.descripcion.toUpperCase().includes(filter[0].toUpperCase())) {
            return true;
          }else {
            return false;
          }
        },      
    },

    data() {
        return {
            fecha1:'',
            fecha2:'',
            filtDisposiciones:{tipo:'0',tema:'0'},
            id:0,
            pieDisposicion:'',
            descripcionDisposicion:'',
            titulo1:'',
            idTipoDisposicion:0,
            fechaDisposicion:'',
            temasSeleccionados:[],

            numeroDisposicion:'',
            numInterno:'',
            idEditar:0,
            idTemaDisposicion:'',
            cuerpoProyectoEditar:'',
            cuerpoProyecto:'',
            idEstado:'',
            titulo:' ',
            arrayTemaDisposicionesFiltrado:[],

            EncabezadoDisposiciones: [
              {
                  key: 'Numero',
              },
              {
                  key: 'fecha',
                  label: 'Fecha',
                  formatter: (value, key, item) => {
                      return item.fecha.substr(8,2)+"/"+item.fecha.substr(5,2)+"/"+item.fecha.substr(0,4);
                  } 
              },           
              {
                  key: 'descripcion',
                  label: 'Descripcion',
              },
             
              {
                  key: 'expe-version',
                  label: 'Expediente',
                      formatter: (value, key, item) => {
                      return  item.version>0 ? item.expediente+" V"+item.version : item.expediente;      
                  }       
              },
              {
                  key: 'show_details',
                  label: 'Temas',
              },              
                             
            ],

            anexos:[],
            insertarAnexo:0,
            arrayIdAnexos:[],

            titulos:[],
            arrayIdTitulos:[],
            insertarTitulo:0,

            MostrarImagen64:'',
            anexosModificar:0,
            nombreTitulo:'',
            titulosModificar:0,
            altaAnexos:true,
            altaTitulos:true,
            anexoPDF:null,

            estadoRenglon:0,
            usuarioRenglon:0,

            criterio:[''],
            id_tipo_expediente:0,
            descripcionProyecto:'',

            link:'',
            nombreLink:'',
        }
    },   
    created(){
      this.CargarEstadosDisposiciones();
      this.CargarTipoDisposiciones();
      this.CargarTemasDisposiciones();
      this.CargarDisposiciones(this.filtDisposiciones);
      this.fecha1=this.fechai;
      this.fecha2=this.fechaf;
    }
  }
</script>
